/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { PropsWithChildren, useCallback } from "react";

import { CosmosText, Wrap } from "@components/elements";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

export type CaptionStackProps = {
	caption?: string | null;
	className?: string | null;
};
export type CaptionProps = PropsWithChildren<
	CaptionStackProps & {
		className?: string;
	}
>;

export const Caption = ({ caption, className, children }: CaptionProps): React.JSX.Element | null => {
	const wrapWithCaption = useCallback(
		(children: React.ReactNode) => (
			<VStack className={cx("caption-stack", className)} justifyContent="center" gap="eds.dimension.14">
				{children}
				<CosmosText
					variant="paragraphSM"
					className={css({ smDown: { textStyle: "paragraphXS" } })}
					color="eds.text.secondary"
					text={caption}
				/>
			</VStack>
		),
		[caption, className],
	);

	return (
		<Wrap condition={!!caption} wrap={wrapWithCaption}>
			{children}
		</Wrap>
	);
};
